import { render, staticRenderFns } from "./editlibrary.vue?vue&type=template&id=3c79e788&scoped=true"
import script from "./editlibrary.vue?vue&type=script&lang=js"
export * from "./editlibrary.vue?vue&type=script&lang=js"
import style0 from "./editlibrary.vue?vue&type=style&index=0&id=3c79e788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c79e788",
  null
  
)

export default component.exports